

const getAmountValueFromCurrency = value =>
  value.replace('$', '').replace(/,/g, '')

export default getAmountValueFromCurrency
